import {
  type FieldValues,
  FormProvider,
  type FormProviderProps,
  type SubmitHandler,
} from 'react-hook-form';

export type FormProps<TFieldValues extends FieldValues> = StrictUnion<
  | (FormProviderProps<TFieldValues> & {
      noHtmlForm?: false;
      onSubmit?: SubmitHandler<TFieldValues>;
    })
  | (FormProviderProps<TFieldValues> & {
      noHtmlForm: true;
    })
>;

export const Form = <TFieldValues extends FieldValues>({
  noHtmlForm = false,
  ...props
}: FormProps<TFieldValues>) => {
  const { onSubmit, handleSubmit } = props;
  if (noHtmlForm) {
    return <FormProvider {...props} />;
  }

  return (
    <FormProvider {...props}>
      <form noValidate onSubmit={onSubmit ? handleSubmit(onSubmit) : undefined}>
        {props.children}
      </form>
    </FormProvider>
  );
};

export { FormField } from './FormField';
export { FormFieldItem } from './FormFieldItem';
export { FormFieldLabel } from './FormFieldLabel';
export { FormFieldHelper } from './FormFieldHelper';
export { FormFieldError } from './FormFieldError';
